import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

interface AlertPopupProps {
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
  open: boolean;
  onClose: () => void;
  actionButton?: React.ReactNode;
}

const AlertPopup: React.FC<AlertPopupProps> = ({ message, severity, open, onClose, actionButton }) => {
  return (
    <Snackbar 
      open={open} 
      autoHideDuration={actionButton ? null : 6000} 
      onClose={onClose} 
      sx={{ zIndex: 9999 }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        action={actionButton}
        sx={{
          width: '100%',
          fontWeight: 'bold',
          padding: '12px 24px',
          ...(severity === 'success' && {
            backgroundColor: '#4CAF50', // A distinct green
            color: '#FFFFFF',
          }),
          ...(severity === 'error' && {
            backgroundColor: '#F44336', // A distinct red
            color: '#FFFFFF',
          }),
          ...(severity === 'warning' && {
            backgroundColor: '#FF9800', // Orange
            color: '#FFFFFF',
          }),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertPopup;
